const setTollFreeDataAt = function (state, data) {
  if(!data || !data?.sid) return

  const {sid, tollFreeRequest} = data
  const collection  = state?.tollFreeStatus
  collection[sid] = tollFreeRequest
  state.tollFreeStatus = {}

  state.tollFreeStatus = collection
  state.tollFreeStatusTracker = crypto.randomUUID()
}

export default setTollFreeDataAt
